import { HARDENING_CLUSTERS } from '@/lib/constants/hardening'
import { MDM_PROFILE_TYPE } from '@/lib/constants/mdm/policies'

// The CIS, Qalea library, Organization and history tabs of the Policies page
export const MDM_POLICY_LISTS = {
  COLUMNS: {
    POLICY: 'Policy',
    CIS_REFERENCE: 'CIS reference',
    SCOPE: 'Scope',
    HOSTS: 'Hosts',
    STATUS: 'Status',
    TYPE: 'Type',
  },
  STATUS: {
    NOT_DEPLOYED: 'Not deployed',
    PENDING: 'Pending',
    DEPLOYED: 'Deployed',
    FAILED: (count: number) => `${count} failed`,
  },
  HOSTS: (applied: number, total: number) => `${applied}/${total} hosts`,
  DEPLOY: 'Deploy',
  SET_UP: 'Set up',
  SEARCH_PLACEHOLDER: 'Search policies...',
  TYPES: {
    [MDM_PROFILE_TYPE.CIS]: 'CIS Benchmark',
    [MDM_PROFILE_TYPE.PREDEFINED]: 'Qalea library',
    [MDM_PROFILE_TYPE.CUSTOM]: 'Organization',
  } as Record<string, string>,
  CIS: {
    TITLE: 'CIS Benchmark · Level 1',
    SUBTITLE: 'Recommended on every host to meet the CIS Benchmark',
    DEPLOYED: 'Deployed',
    DEPLOYED_COUNT: (deployed: number, total: number) => `${deployed} of ${total}`,
    DISK_ENCRYPTION_PLATFORMS: 'macOS and Windows',
    CHECKS: {
      [HARDENING_CLUSTERS.PASSWORD_SECURITY]: 'Long passwords with mixed characters',
      [HARDENING_CLUSTERS.DISK_ENCRYPTION]: 'FileVault and BitLocker, recovery key saved',
      [HARDENING_CLUSTERS.SCREEN_LOCK]: 'Locks after 5 minutes idle',
      [HARDENING_CLUSTERS.PRIVILEGE_PROTECTION]: 'Admins confirm every elevation',
      [HARDENING_CLUSTERS.HOST_FIREWALL]: 'Firewall on for every network',
    } as Record<string, string>,
  },
  LIBRARY: {
    SUBTITLE: 'Optional policies prepared by Qalea',
    EMPTY: 'No Qalea policies yet',
  },
  ORGANIZATION: {
    SEARCH_PLACEHOLDER: 'Search your policies...',
    SUBTITLE: 'Policies created by your team',
    ALL_HOSTS: 'All hosts',
    EMPTY: 'No policies yet',
  },
  DRAWER: {
    DETAILS: 'Details',
    TYPE: 'Type',
    PLATFORM: 'Platform',
    CIS_REFERENCE: 'CIS reference',
    SCOPE: 'Scope',
    LAST_DEPLOYED: 'Last deployed',
    HOSTS: 'Hosts',
    HOSTS_TITLE: (count: number) => `Hosts (${count})`,
    NEVER: 'Never',
    NOT_DEPLOYED: 'Not deployed yet',
    CLOSE: 'Close',
    REDEPLOY: 'Redeploy',
  },
}
